import React from 'react'
import injectSheet from 'react-jss'
import {
  TitleContainer,
  AdminUserListItem,
} from '../../'

const AdminUserList = (props) => {
  const {
    classes,
    data,
  } = props

  return (
    <TitleContainer title="Benutzer">
      <ul className={`${classes.list}`}>
        {data && data.loading && <p>Loading...</p>}
        {data && data.error && <p>Error :(</p>}
        {data && !data.loading && !data.error && data.users.map(user => (
          <li
            key={`${user.id}`}
          >
            <AdminUserListItem user={user} />
          </li>
        ))}
      </ul>
    </TitleContainer>
  )
}

const styles = theme => ({
  list: {
    listStyleType: 'none',
    margin: 0,
    padding: `0 ${theme.sizes.gutter / 2}px`,
  },
})


export default injectSheet(styles)(AdminUserList)



// WEBPACK FOOTER //
// ./src/modules/admin/components/adminUserList.jsx